module.exports = __webpack_public_path__ + "img/img2.14207df8.png";